import Types from "../actions/types";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import {
	authHeaders,
	tokenExists,
	getOrganisationBaseUrlByGuid,
} from "frame";

import {
	organisationStatusUpdateSuccess,
	organisationStatusUpdateFailed,
	organisationFetch,
} from "../actions";

export const organisationStatusUpdateEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.ORGANISATION_STATUS_UPDATE),
		filter(() => tokenExists()),
		mergeMap(({ payload }) => {
			const { organisationId, name, status } = payload;
			const baseUrl = getOrganisationBaseUrlByGuid(organisationId);
			return ajax
				.post(
					`${baseUrl}/organisation/update`,
					{
						id: organisationId,
						name,
						status,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							organisationFetch(),
							organisationStatusUpdateSuccess(payload)
						)
					),
					catchError((error) =>
						of(organisationStatusUpdateFailed(error))
					)
				);
		})
	);
